import { CompanyConfig, getActiveCompanyConfig } from "domain/company/companyConfig";

import { Line } from "types/canvasTypes";

export function calculateLineLength(line: Line, scale: number): number {
  const { start, end } = line;
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const length = Math.sqrt(dx * dx + dy * dy);

  return Math.round(length * 100) / 100 / scale;
}

export function calculateNumberOfGlassBasedOnBiggestGlass(
  length: number,
  biggestGlass: number
): number {
  const divisionResult = length / biggestGlass;

  if (divisionResult - Math.floor(divisionResult) > 0.05) {
    return Math.ceil(divisionResult);
  }

  return Math.floor(divisionResult);
}

export function calculateNumberOfGlass(
  line: Line,
  scale: number,
  companyConfig: CompanyConfig = getActiveCompanyConfig()
): number {
  const doorWidth = companyConfig.catalog.doorWidth;
  const numberOfDoors = line.numberOfDoors;
  let tempLength = calculateLineLength(line, scale);

  if (numberOfDoors === 1) {
    tempLength -= doorWidth;
  }
  if (numberOfDoors === 2) {
    tempLength -= doorWidth * 2;
  }

  const biggestGlass =
    numberOfDoors > 0
      ? companyConfig.rules.doorMaxGlassLength
      : companyConfig.rules.nonDoorMaxGlassLength;

  let numberOfGlass = calculateNumberOfGlassBasedOnBiggestGlass(
    tempLength,
    biggestGlass
  );

  if (line.numberOfDoors === 1 && numberOfGlass === 0) {
    numberOfGlass = 1;
  }

  if (line.numberOfDoors === 2 && (numberOfGlass === 1 || numberOfGlass === 2)) {
    numberOfGlass = 2;
  }

  return numberOfGlass;
}
